import { ScoreLabel } from './enums';

export function scoreToLabel(score: number): ScoreLabel {
  if (score <= 2) return ScoreLabel.CRAWL;
  if (score <= 4) return ScoreLabel.WALK;
  return ScoreLabel.RUN;
}
